import { render, staticRenderFns } from "./LoaderLogo.vue?vue&type=template&id=068e35d4&scoped=true"
import script from "./LoaderLogo.vue?vue&type=script&lang=js"
export * from "./LoaderLogo.vue?vue&type=script&lang=js"
import style0 from "./LoaderLogo.vue?vue&type=style&index=0&id=068e35d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2cae27f83758b46b73a9745eca16177c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068e35d4",
  null
  
)

export default component.exports